import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	headerNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentRestMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentWarningLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentWillAffectIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentYouCanChangeIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeComponentRadio: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeComponentRadio: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	componentPickerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentCountIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentRestMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentWarningLinkIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentWillAffectIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteComponentYouCanChangeIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeComponentRadioIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeComponentRadioIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line @atlassian/i18n/no-multiple-plurals
} = defineMessages({
	headerNew: {
		id: 'project-directories.components.delete.header-new',
		defaultMessage: 'Delete {component} component',
		description:
			'Title of a modal dialog that asks user for confirmation before deleting a Project Component',
	},
	deleteButton: {
		id: 'project-directories.components.delete.delete-button',
		defaultMessage: 'Delete',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	cancelButton: {
		id: 'project-directories.components.delete.cancel-button',
		defaultMessage: 'Cancel',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentCount: {
		id: 'project-directories.components.delete.delete-component-count',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentRestMessage: {
		id: 'project-directories.components.delete.delete-component-rest-message',
		defaultMessage:
			' use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this issue} other {these issues}}.',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentWarningLink: {
		id: 'project-directories.components.delete.delete-component-warning-link',
		defaultMessage:
			'{relatedIssueCount, plural, one {There is 1 issue} other {There are {relatedIssueCount} issues}} using this component.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues. This sentence will be a link that points to the list of all affected issues.',
	},
	deleteComponentWillAffectIssues: {
		id: 'project-directories.components.delete.delete-component-will-affect-issues',
		defaultMessage:
			'Deleting this component will affect {relatedIssueCount, plural, one {this issue} other {these issues}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	deleteComponentYouCanChangeIssues: {
		id: 'project-directories.components.delete.delete-component-you-can-change-issues',
		defaultMessage:
			'You can change the component or remove the component {relatedIssueCount, plural, one {from this issue} other {from these issues}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	changeComponentRadio: {
		id: 'project-directories.components.delete.change-component-radio',
		defaultMessage: 'Change current issues to component',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. This is a label of selectbox, to choose another component. Jira will then migrate all issues to use the new component instead of the deleted one. "Issues" in this context means "Jira tickets".',
	},
	removeComponentRadio: {
		id: 'project-directories.components.delete.remove-component-radio',
		defaultMessage: 'Remove component from all issues.',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	componentPickerPlaceholder: {
		id: 'project-directories.components.delete.component-picker-placeholder',
		defaultMessage: 'Select component',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentCountIssueTermRefresh: {
		id: 'project-directories.components.delete.delete-component-count-issue-term-refresh',
		defaultMessage: '{count} {count, plural, one {work item} other {work items}}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentRestMessageIssueTermRefresh: {
		id: 'project-directories.components.delete.delete-component-rest-message-issue-term-refresh',
		defaultMessage:
			' use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this work item} other {these work items}}.',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	deleteComponentWarningLinkIssueTermRefresh: {
		id: 'project-directories.components.delete.delete-component-warning-link-issue-term-refresh',
		defaultMessage:
			'{relatedIssueCount, plural, one {There is 1 work item} other {There are {relatedIssueCount} work items}} using this component.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues. This sentence will be a link that points to the list of all affected issues.',
	},
	deleteComponentWillAffectIssuesIssueTermRefresh: {
		id: 'project-directories.components.delete.delete-component-will-affect-issues-issue-term-refresh',
		defaultMessage:
			'Deleting this component will affect {relatedIssueCount, plural, one {this work item} other {these work items}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	deleteComponentYouCanChangeIssuesIssueTermRefresh: {
		id: 'project-directories.components.delete.delete-component-you-can-change-issues-issue-term-refresh',
		defaultMessage:
			'You can change the component or remove the component {relatedIssueCount, plural, one {from this work item} other {from these work items}}.',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. Users need to decide what to do with these issues before they can proceed with deleting. "Issues" in this context means "Jira tickets". {relatedIssueCount} is a variable that will contain a number of affected issues.',
	},
	changeComponentRadioIssueTermRefresh: {
		id: 'project-directories.components.delete.change-component-radio-issue-term-refresh',
		defaultMessage: 'Change current work items to component',
		description:
			'This message shows when users are trying to delete a Project Component but the component is assigned to some issues. This is a label of selectbox, to choose another component. Jira will then migrate all issues to use the new component instead of the deleted one. "Issues" in this context means "Jira tickets".',
	},
	removeComponentRadioIssueTermRefresh: {
		id: 'project-directories.components.delete.remove-component-radio-issue-term-refresh',
		defaultMessage: 'Remove component from all work items.',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
